import type { DeleteConsequencesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

const mapTrpcResponseToGraphQL = (
  count: number
): DeleteConsequencesMutation => {
  return {
    delete_consequence: {
      __typename: 'consequence_mutation_response',
      affected_rows: count,
    },
  };
};

export const useDeleteConsequencesTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.consequence.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.consequence.register.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.consequence.consequenceById.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.consequence.getByParentIssueId.queryKey(),
        });
      },
    }),
  });

  return {
    deleteConsequences: async (variables: {
      Ids: string[];
    }): Promise<DeleteConsequencesMutation> => {
      const result = await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL(result.deletedCount);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
